import { render, staticRenderFns } from "./CriarConcurso.vue?vue&type=template&id=f3cbb67a"
import script from "./CriarConcurso.vue?vue&type=script&lang=ts"
export * from "./CriarConcurso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports